/**
 * Query parameters that carry free text a person typed into a search box.
 *
 * Not a chart dimension and routinely a colleague's or member's name or email,
 * so replay keeps the request but not the term. Every other parameter is left
 * alone: replay is the BAA-covered product plane, and an id in a query string
 * is a dimension worth keeping there.
 */
const SEARCH_TERM_PARAMS = ['q'] as const;

/**
 * The URL without its search-term parameters, or `null` when it carries one
 * and cannot be parsed — dropping the request is the fail-closed answer.
 */
export function withoutSearchTerms(url: string): string | null {
  const carriesTerm = SEARCH_TERM_PARAMS.some((param) => new RegExp(`[?&]${param}=`).test(url));
  if (!carriesTerm) return url;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  for (const param of SEARCH_TERM_PARAMS) parsed.searchParams.delete(param);
  return parsed.toString();
}
